import React, { useEffect, useRef, useState } from 'react'
import {RhyBusButton as Buttons} from '@rhybus/button';
import AddeditView from './add-edit'
import {  DELETE_ITEM, ListNames } from '../../config/configuration';
import { RhyBusNoresult } from '@rhybus/noresult'
import {RhyBusAlert as Alert} from '@rhybus/alert'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay';
import { rhybusRListsHttp } from '../../api/rhybus-list-http';
import { convertDate, DocumentIconNames } from '@rhybus/common-functions';



const PmgData = (props: any) => {
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [deleteDecision, setDeleteDecision] = useState<boolean>()
  const [editFile, setEditFile] = useState(false)
  const [editFileName, setEditFileName] = useState('')
  const [loading, setLoading] = useState(false)
  const [item, setItem] = useState<any>(null)
  const popupBodyRef = useRef<HTMLDivElement>(null)
  const [deleteItem, setDeleteItem] = useState<any>(null)
  const [fileItems, setFileItems] = useState<any>()
  const [files, setFiles] = useState<any>()
  const [selectedFile, setSelectedFiles] = useState({})
  const [generalFolder, setGeneralFolder] = useState<any>()
  const match = generalFolder?.match(/[0-9a-fA-F-]{36}/)

  function addeditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
  }

  useEffect(() => {
    if (props?.list?.eKey) {
      const getFiles = async () => {
        const files = await getFilesForFolder(props?.list?.eKey, props?.files)
        setFileItems(files)


      }
      getFiles()

    }

  }, [props?.list?.eKey, props.pmddata, props?.generalFolderpmg, props?.files])

  const [inEditMode, setInEditMode] = useState({
    status: false,
    rowKey: null,
  })
  /* Function call on edit */
  const onEdit = (item: any) => {
    props?.onFileEditOpen?.(props?.list?.eKey, item?.eKey)
    setInEditMode({
      status: true,
      rowKey: item?.eKey,
    })
    setEditFile(true)
    setSelectedFiles(item)
    setEditFileName(item?.fileName)
  }
  /* Function call on cancel */
  const onCancel = () => {
    props?.onFileEditClose?.()
    setInEditMode({
      status: false,
      rowKey: null,
    })
    setEditFile(false)
  }

  useEffect(() => {
    setShowAlert(false)
  }, [deleteDecision])

  const onDelete = async (item: any, mainFolderName: any) => {
    setShowAlert(true)
    setDeleteItem(item)
    setItem(item)
  }

  const getFilesForFolder = (eKey: string, filesToFilter?: any[]) => {
    const filesArr = filesToFilter ?? files
    const requiredBlobs = filesArr?.filter((blob: any) => blob?.itemKey === `${ListNames.POLICY_MEMO}__${eKey}`)
    const str = requiredBlobs[0]?.itemKey
    setGeneralFolder(str)

    const filteredFiles = requiredBlobs?.[0]?.blobs?.filter((item: any) => !item?.fileName?.includes('IsDeleted'))
    return filteredFiles
  }
  const getFileExtensionByFileName = (fileName: string): string => {
  const ext = fileName.split('.')?.pop();
  return ext || '';
};
 const btnOutlinedCRUDOperationsUI = {
  Add: {
    Label: 'Add',
    Icon: 'icon-add font-12 pe-lg-1',
    ClassName: '',
  },
  Edit: {
    Label: 'Edit',
    Icon: 'icon-rb-pencil font-12 pe-lg-1',
    ClassName: '',
  },
  Delete:{
    Label: 'Delete',
    Icon: 'icon-rb-trashbin font-12 pe-lg-1',
    ClassName: '',
  }
}
 
const FileTypes: { [key: string]: string } = { // Added index signature
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  jpe: 'image/jpeg',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  msg: '',
  pdf: 'application/pdf',
  png: 'image/png',
  pps: 'application/vnd.ms-powerpoint',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
function getFileType(fileName: string) {
  const extension = fileName.split('.').pop()
  return extension ? FileTypes[extension] : ''
}
const fileReturnType = (productMap: Map<string, unknown>) => {
  for (const [key, value] of productMap) {
    if (key === 'type') {
      return value
    }
  }
}
const SUPPORTED_FILE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'msg', 'ppt', 'pptx']
 async function openFile(
  file: any,
  ekey: string,
  listName: string
): Promise<void> {
  if (file) {
    const extension = getFileExtensionByFileName(file?.fileName)
    const list = await rhybusRListsHttp().getList(listName)
    await list
      .blobs()
      .getContent(ekey, file?.fileName, file?.folderName)
      .then(function (data) {
        const metadataMap =
          file?.metadata instanceof Map
            ? file?.metadata
            : new Map(Object.entries(file?.metadata || {})) // Added nullish coalescing
        let filetype = fileReturnType(metadataMap as Map<string, unknown>) // Type assertion
        if (filetype === undefined || filetype === '') {
          filetype = getFileType(file?.fileName)
        }
        const blob = new Blob([data], { type: filetype as string }) // Type assertion
        const blobURL = window.URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
 
        if (extension && SUPPORTED_FILE_EXTENSIONS.includes(extension)) {
          tempLink.setAttribute('download', file?.fileName)
        } else {
          tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(blobURL)
        }, 100)
      })
      .catch((error:any) => {
        console.error(error)
      })
  }
}
 
  const onClickAlert = async (button: string, item: any, itemKey: string) => {

      if (button === 'YES') {
          const list = await rhybusRListsHttp().getList(ListNames.POLICY_MEMO)
          try {
            // Attempt to delete the file
            await list.blobs().delete(
              itemKey as string,
              item?.fileName,
              item?.folderName,
              item?.eTag
            )
          } catch (error) {
            console.error('Error during deletion:', error)
          } finally {
            // Close alert and reset state
            props?.setFlag(!props?.flag)
            setShowAlert(false)
            setDeleteItem(null)
          }
          props?.setIsConfirmed(false)
          props?.setGeneralFolderpmg('')
        }
    else {
      setShowAlert(false)
      setDeleteItem(null)
    }
  }
  useEffect(() => {
    if ((showAddPopup || inEditMode) && popupBodyRef.current) {
      const focusableElements = popupBodyRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      if (focusableElements.length > 0) {
        (focusableElements[0] as HTMLElement).focus()
      }
    }
  }, [showAddPopup, inEditMode])


  return (
    <>
      {loading ? (
        <PageOverlay />
      ) : (
        <div className='container'>
          <div className='row m-0 '>
            <div className='p-0 max-h-fit-content'>
             {fileItems && fileItems.length > 0 ? (
 fileItems.map((poclist: any) => (
    <div
      className='d-flex flex-column settings-bordered border-radius-2 mb-2 p-2'
      key={poclist?.fileName}
    >
      <div className='d-flex'>
        <div className='d-flex flex-column flex-row-md flex-nowrap w-100'>
          <div className='d-flex align-items-center me-auto text-break font-12'>
            <span className={`${DocumentIconNames(poclist?.fileName)} color-primary pe-1 font-14`}></span>
            <a
              tabIndex={0}
              aria-label={poclist?.fileName}
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  openFile(poclist, poclist?.eKey, ListNames.POLICY_MEMO);
                }
              }}
              onClick={() => openFile(poclist, match[0], ListNames.POLICY_MEMO)}
              download
              target="_blank"
              title={poclist?.fileName}
              rel="noreferrer"
              className="links1  fw-semibold font-13 links-over-underline links"
            >
              {poclist?.fileName}
            </a>
          </div>
          <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
          <div className='d-flex flex-column min-w-md-150 w-100 max-w-md-150 text-break font-12'>
            <span className='rb-card-header-item-title font-13 '>Created</span>
            <span className=' font-14'>
              {poclist?.metadata?.createdby + ' | ' + convertDate(poclist?.createdOn, 'date')}
            </span>
          </div>
          <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
          <div className='d-flex flex-column min-w-md-150 w-100 max-w-md-150 text-break font-12'>
            <span className='rb-card-header-item-title font-13 '>Modified</span>
            <span className=' font-14'>
              {poclist?.metadata?.createdby + ' | ' + convertDate(poclist?.modifiedOn, 'date')}
            </span>
          </div>
          <div className='dividerdashed vertical mx-2 mx-xxl-3 d-none d-block-md'></div>
        </div>
        <div className='d-flex align-items-center'>
          <div className='d-flex align-items-center gap-1 ms-auto '>
            <Buttons
              leftIcon={btnOutlinedCRUDOperationsUI.Edit.Icon}
              label={btnOutlinedCRUDOperationsUI.Edit.Label}
              className={btnOutlinedCRUDOperationsUI.Edit.ClassName}
              onClick={() => onEdit(poclist)}
              variant='secondary'
            />
            <Buttons
              leftIcon={btnOutlinedCRUDOperationsUI.Delete.Icon}
              label={btnOutlinedCRUDOperationsUI.Delete.Label}
              className={btnOutlinedCRUDOperationsUI.Delete.ClassName}
              onClick={() => onDelete(poclist, props?.list)}
              variant='secondary'
            />
          </div>
        </div>
      </div>

      {props?.activeFileEdit?.folderEKey === props?.list?.eKey && props?.activeFileEdit?.fileEKey === poclist?.eKey && (
        <AddeditView
          cancel={() => onCancel()}
          filtersvalue={addeditValue}
          showAddEdit={showAddPopup}
          folderName={editFileName}
          editFile={editFile}
          details={props?.list}
          flag={props?.flag}
          setFlag={props?.setFlag}
          popupBodyRef={popupBodyRef}
          Section={props?.Section}
          selectedFile={selectedFile}
          setShowAddEdit={props?.setShowAddEdit}
          fetchData={props?.fetchData}
          toSetfolders={props?.toSetfolders}
          setAddFolderFile={props?.setAddFolderFile}
          AddType={1} // Explicitly set AddType to 1 for file edits
          editFileValue={editFileName} // Pass the full file name for add-edit.tsx to use
        />
      )}
    </div>
  ))
) : (
 <div className='min-h-200 d-flex align-items-center justify-content-around'>
        <RhyBusNoresult />
      </div>
)}

              {props?.folder?.length === 0 && props?.files?.length === 0 && (
                <div className='min-h-200 d-flex align-items-center justify-content-around settings-bordered whitebg'>
                  <RhyBusNoresult />
                </div>
              )}
            </div>
          </div>
          {showAlert && (
            <Alert
              size='md'
              show={showAlert}
              variant='confirm'
              message={DELETE_ITEM}
              confirmLabel='YES'
              cancelLabel='NO'
              onConfirm={() => onClickAlert('YES', deleteItem, match?.[0])}
              onCancel={() => onClickAlert('NO', deleteItem, match?.[0])}
            />
          )}
        </div>
      )}
    </>
  )
}
export default PmgData